import { config } from "./config.js";
import { stableStringify, sha1 } from "./utils.js";

async function buildSignedPayload(payload) {
  const json = stableStringify(payload);
  console.log("Payload JSON:", json);
  const sign = await sha1(json);
  return { payload, sign };
}

export async function sendLogApi(type, payload) {
  const path = `/api/v1/log/${type}`;
  if (!config.apiBase) return;

  const body = await buildSignedPayload(payload);
  const url = `${config.apiBase + path}?sign=${body.sign}`;
  console.log("Sending API to", url, body);

  return fetch(url, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body.payload)
  });
}
